module.exports = __webpack_public_path__ + "img/55.55f8d67a.jpg";